import { Node, ReactNodeViewRenderer } from '@tiptap/react';
import { WhyHomeOwnersTrustUsBlockView } from './WhyHomeOwnersTrustUsBlockView';

export const WhyHomeOwnersTrustUs = Node.create({
    name: 'whyhomeownerstrustus',

    group: 'block',

    defining: true,

    isolating: true,

    parseHTML() {
        return [
            {
                tag: `div[data-type="${this.name}"]`,
            },
        ];
    },

    renderHTML() {
        return [
            'div',
            {
                'data-type': 'whyhomeownerstrustus',
                class: 'offers-block',
            },
            'Why Home Owners Trust Us Block'
        ];
    },

    addCommands() {
        return {
            setWhyHomeOwnersTrustUs:
                () =>
                    ({ commands }) => {
                        return commands.insertContent({
                            type: this.name,
                        });
                    },
        };
    },

    addNodeView() {
        return ReactNodeViewRenderer(WhyHomeOwnersTrustUsBlockView);
    },
});